import axios from "axios";
import store from "./store";
import * as actions from "./store/actions";
import { bugsnagClient } from "./services/bugsnag";
import i18next from "i18next";
/**
 * List of endpoint const's
 */
export const SEND_PROVE_OF_PAYMENT = "/api/dossier/payment_prove";
export const SEND_CONTACT_REQUEST = "/api/dossier/contact";
export const LOGIN = "/api/auth/login";
export const SWITCH_DOSSIER = "/api/dossier/switch";
export const AUTO_LOGIN = "/api/auth/autologin";
export const FETCH_DOSSIER = "/api/dossier";
export const FETCH_DOSSIER_INVOICES = "/api/dossier/invoice";
export const FETCH_FAQS = "/api/faqs";
export const VERIFY_PAYMENT = "/api/payment/verify";
export const FETCH_PAYMENT_REDIRECT_URL = "/api/payment/redirect";
export const VERIFY_OPEN_PAYMENT = "/api/open_payment/verify";
export const FETCH_OPEN_PAYMENT_REDIRECT_URL = "/api/open_payment/redirect";
export const TOGGLE_MAIL_SUBSCRIPTION = "/api/dossier/mail_subscription";
export const POST_PAYMENT_ARRANGEMENT_REQUEST = "/api/payment/arrangement";
export const EDIT_EMAIL_ADDRESS = "/api/dossier/edit-email";
export const FETCH_DOSSIER_LIST = "/api/dossier/list";
export const FETCH_PAYMENT_PLAN_REQUEST_MULTIPLE_DOSSIERS_CRITERIA = "/api/dossier/payment-plan-request/multiple-dossiers/criteria";
export const PAYMENT_ARRANGEMENT_PROPOSITIONS = "/api/payment/arrangement/propositions";
if (typeof window !== "undefined") {
    /**
     * Set default bearer on all Axios requests
     */
    const token = localStorage.getItem("access_token");
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}
/**
 * Logout users when response is 401
 */
axios.interceptors.response.use(undefined, error => {
    const t = i18next.t.bind(i18next);
    // Leave a breadcrumb
    bugsnagClient.leaveBreadcrumb(error.message);
    if (!error.status) {
        // Translate network error
        error.message = t("error.network_error");
    }
    if (error.status === 500 && !error.message) {
        error.message = t("error.server_error");
    }
    if (error.status === 401 ||
        (error.response && error.response.status === 401)) {
        store.dispatch(actions.authDossierLogout(true));
        return Promise.reject({
            status: 401,
            message: t("error.authentication_error"),
        });
    }
    return Promise.reject(error);
});
export const errorsTransformer = (err) => {
    const t = i18next.t.bind(i18next);
    const status = (err.response && err.response.status) || err.status;
    if (err.response && err.response.data) {
        let { errors = {}, message } = err.response.data;
        if (Array.isArray(errors)) {
            errors = {
                generic_error: errors[0],
            };
        }
        else if (typeof errors === "string") {
            errors = {
                generic_error: errors,
            };
        }
        if (Object.keys(errors).length === 0) {
            errors.generic_error = message || t("error.generic_error");
        }
        return {
            status,
            message: typeof errors === "string" ? errors : message,
            errors: typeof errors === "string" ? {} : errors,
        };
    }
    let message = status && err.message ? err.message : t("error.connection_error");
    if (status === 500) {
        message = t("error.generic_error");
    }
    return {
        status,
        message,
        errors: {
            generic_error: message,
        },
    };
};
export default axios;
